import { addDays, daysBetween, type Period } from '@fd/finance-core';

/** Chart samples stay sparse; period totals always use the exact boundary dates. */
export function netWorthDatePlan(start: string, end: string, earliest: string, period?: Pick<Period, 'start' | 'end'>) {
  const step = Math.max(1, Math.ceil(daysBetween(start, end) / 120));
  const chartDates: string[] = [];
  for (let date = end; date >= start; date = addDays(date, -step)) chartDates.push(date);
  if (chartDates.at(-1) !== start) chartDates.push(start);

  const before = period ? addDays(period.start, -1) : null;
  // Do not label a partial history or a future period as a measured change.
  const comparison = period && before && before >= earliest && period.start <= end
    ? { start: before, end: period.end < end ? period.end : end }
    : null;
  const dates = [...new Set([...chartDates, ...(comparison ? [comparison.start, comparison.end] : [])])].sort();
  return { dates, chartDates, comparison };
}
